module.exports = __webpack_public_path__ + "static/media/mgmotor.d267a04e.png";